module.exports = __webpack_public_path__ + "img/599.f925626b.jpg";